<template>
  <a-card :bordered="false" >
    <a-row style="margin-bottom: 40px;">
      <a-col span="12" class="topTitle">设置打印价格，设置后用户选择对应打印数量则对应不同价格</a-col>
      <a-col span="12">
        <a-button type="primary" @click="editType=true" v-if="!editType">编辑</a-button>
        <a-button @click="editType=false" v-if="editType">取消</a-button>
        <a-button type="primary" v-if="editType" @click="save" class="ml10">保存</a-button>
      </a-col>
    </a-row>
    <div class="flex mt10" v-for="(item, index) in arr" :key="index">
      <a-input
        type="number"
        min="0"
        style="width: 90px;"
        onkeyup="(this.v=function(){this.value=this.value.replace(/[^0-9-]+/,'');}).call(this)"
        onblur="this.v();"
        :disabled="!editType"
        v-model="item.min_number"></a-input>
      <div class="mlr10">张&lt;打印云码数量&lt;=</div>
      <a-input
        type="number"
        min="0"
        style="width: 90px;"
        v-model="item.max_number"
        onkeyup="(this.v=function(){this.value=this.value.replace(/[^0-9-]+/,'');}).call(this)"
        onblur="this.v();"
        :disabled="!editType"></a-input>
      <div class="mlr10">张，单张打印单价为</div>
      <a-input
        type="number"
        min="0"
        style="width: 90px;"
        v-model="item.price"
        onkeyup="(this.v=function(){this.value=this.value.replace(/[^\d+(,\d\d\d)*.\d+$]/g ,'');}).call(this)"
        onblur="this.v();"
        :disabled="!editType"></a-input>
      <div class="mlr10">元</div>
      <a-button style="margin-left: 40px;" @click="deleteArrs(index)" v-if="editType">删除</a-button>
      <a-button class="ml10" @click="add" v-if="(index+1) === arr.length && editType" type="primary" >新增一条</a-button>
    </div>
  </a-card>
</template>
<script>
import { printSave, printPre } from '@/api/programme'
import _ from 'lodash'
export default {
  name: 'Code',
  data () {
    return {
      arr: [],
      editType: false
    }
  },
  mounted () {
    this.getPre()
  },
  methods: {
    save () {
      const params = {
        price_setting: this.arr
      }
      printSave(params).then(res => {
        if (_.get(res, 'code') === 200) {
          this.$message.success('保存成功')
          this.editType = false
        } else {
          this.$message.error(res.message)
        }
      })
    },
    getPre () {
      printPre().then(res => {
        if (_.get(res, 'code') === 200) {
          const data = _.get(res, 'data', [])
          if (data.length === 0) {
            const newArr = {
              min_number: '0',
              max_number: '0',
              price: '0'
            }
            this.arr.push(newArr)
          } else {
            this.arr = data
          }
        }
      })
    },
    add () {
      const arr = {
        min_number: '0',
        max_number: '0',
        price: '0'
      }
      this.arr.push(arr)
    },
    deleteArrs (index) {
      if (this.arr.length === 1) {
        return
      }
      this.arr.splice(index, 1)
    }
  }
}
</script>

<style scoped>
  .flex {
    display: flex;
    align-items: center;
  }
  .flex_w {
    flex-wrap: wrap;
  }
  .topTitle {
    font-weight: 700;
    font-size: 18px;
  }
  .mt10 {
    margin-top: 10px;
  }
  .mt20 {
    margin-top: 20px;
  }
  .mt40 {
    margin-top: 40px;
  }
  .ml10 {
    margin-left: 10px;
  }
  .mlr10 {
    margin: 0 10px;
  }
  .mr20 {
    margin-right: 20px;
  }
</style>
